module.exports = __webpack_public_path__ + "img/2025-04-12b_3.ba2c6cc1.jpg";